import { z } from 'zod'

export const welcomeBackPromotionSegmentSchema = z.enum(['LOW', 'MEDIUM', 'MID', 'HIGH'])
export type WelcomeBackPromotionSegment = z.infer<typeof welcomeBackPromotionSegmentSchema>

/**
 * Response schema for expired-customer promotion eligibility.
 */
export const welcomeBackPromotionSchema = z.object({
  eligible: z.boolean().describe('Promotion eligibility'),
  segment: welcomeBackPromotionSegmentSchema
    .nullable()
    .describe('Segment. LOW is low frequency. MEDIUM, MID, and HIGH use the mid/high-frequency 20% UX.'),
  redirectUrl: z.string().nullable().describe('Detail page URL'),
  studentName: z.string().describe('Student name'),
  expiredAt: z.string().nullable().describe('Last expiration date'),
  avgLessonsPerMonth: z.number().nullable().describe('Average lessons per month'),
})

export type WelcomeBackPromotion = z.infer<typeof welcomeBackPromotionSchema>

/**
 * Raw backend API response type in snake_case.
 */
export interface RawWelcomeBackPromotion {
  eligible: boolean
  segment: WelcomeBackPromotionSegment | null
  redirect_url: string | null
  student_name: string
  expired_at: string | null
  avg_lessons_per_month: number | null
}
